import "babel-polyfill";
import Vue from "../lib/vue";
import Profile from "../company/profile";
import JobsPage from "../pages/jobs";
import FeaturedCompanies from "../components/featured-companies";
import FeaturedIndividuals from "../components/featured-individuals";
import FeaturedProjects from "../components/featured-projects";
import FeaturedJobs from "../components/featured-jobs";
import FeaturedArticles from "../components/featured-articles";
import CompaniesPage from "../pages/companies";
import IndividualsPage from "../pages/individuals";
import CmButton from "../components/cm-button";
import Checkout from "../components/checkout";
import PreviewCard from "../onboarding/preview-card";
import ChapterBox from "../company/chapter-box.vue";
import CmNavChapterDropdowns from "../components/cm-nav-chapter-dropdown";
import CmChapterDropdowns from "../components/cm-chapter-dropdowns";
import CitiesMap from "../components/cities-map";
import DonationForm from "../components/donation-form";
import LocationField from '../components/location-field'

import {setScrollbarWidth} from "../lib/scrollbar";
import initYoutubeIframeAPI from "../lib/youtube-iframes";
import fitvids from "fitvids";

window.I18n = { ...window.I18n };
window.I18n.locale = document.documentElement.lang;
Vue.prototype.I18n = window.I18n;

// helper to mount vue safely with just a dom-selector and a render function
const mountVue = ({ selector, render }) => {
  const nodes = [...document.querySelectorAll(selector)];
  if (nodes.length) {
    nodes.forEach((node) => {
      new Vue({
        render: (t) => render(t, node),
      }).$mount(node);
    });
  }
};

window.mountComponents = () => {
  mountVue({
    selector: "chapter-box",
    render: (t, node) =>
      t(ChapterBox, {
        props: { 
          chapter: JSON.parse(node.getAttribute("chapter")),
          badge: node.getAttribute("badge") 
        },
      }),
  });
  mountVue({
    selector: "cities-map",
    render: (t, node) => t(CitiesMap, {
      props: {
        type: node.getAttribute("type"),
      }
    }),
  });
  mountVue({
    selector: "cm-nav-chapter-dropdown",
    render: (t, node) => t(CmNavChapterDropdowns, {
      props: { currentChapterAbbr: node.getAttribute("current-chapter-abbr") },
    }),
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".page--home")) {
    new Vue({
      el: ".page--home",
      components: {
        CmButton,
        FeaturedCompanies,
        FeaturedIndividuals,
        FeaturedArticles,
        FeaturedJobs,
        FeaturedProjects,
        CmChapterDropdowns,
        CitiesMap,
      },
    });
  }

  mountVue({
    selector: "location-field",
    render: (t, node) => {
      let props = {};
      
      if (node.hasAttribute("model")) {
        props = {
          model: node.getAttribute("model"),
          attribute: node.getAttribute("attribute"),
          value: JSON.parse(node.getAttribute("value")),
          placeholder: node.getAttribute("placeholder"),
          required: node.hasAttribute("required"),
          disabled: node.hasAttribute("disabled"),
          types: node.getAttribute("types"),
        };
      }
      return t(LocationField, { props });
    },
  });

  mountVue({
    selector: "featured-jobs",
    render: (t) => t(FeaturedJobs),
  });

  mountVue({
    selector: "#js-company",
    render: (t, node) => {
      let props = {};
      if (node.hasAttribute("data-company")) {
        props = {
          company: JSON.parse(node.getAttribute("data-company")),
          admin: node.hasAttribute("data-admin"),
          breakfastFoods: window.I18n.t("breakfast_foods"),
          stub: node.hasAttribute("data-stub"),
          form: node.hasAttribute("data-form"),
        };
      }
      return t(Profile, { props });
    },
  });

  mountVue({
    selector: "#keyword-input-container",
    render: (t) =>
      t(JobsPage, {
        props: {
          filters: window.__DATA__.jobs_filters.map((filter) => {
            const isMultiple = ["skill_tag_id", "commitment"].includes(
              filter.option_name
            );
            const options = filter.options.map((option) => ({
              label: option.name,
              value: option.val.toString(),
            }));

            return {
              ...filter,
              id: filter.option_name,
              multiple: isMultiple,
              nullLabel: isMultiple ? options[0].label : undefined,
              options: options.filter((option, index) =>
                isMultiple ? index > 0 : true
              ),
            };
          }),
        },
      }),
  });

  mountVue({
    selector: "#companies-container",
    render: (t) =>
      t(CompaniesPage, {
        props: {
          favorites: window.__DATA__.user_favorite_companies,
          isLoggedIn: window.__DATA__.logged_in,
          filters: window.__DATA__.companies_filters
            .map((filter) => {
              const isMultiple = ["skill_tag_id", "industry_id"].includes(
                filter.option_name
              );
              const options = filter.options.map((option) => ({
                label: option.name,
                value: option.val.toString(),
              }));

              const hasNullOption = filter.option_name !== "sort_key";

              return {
                ...filter,
                id: filter.option_name,
                multiple: isMultiple,
                nullLabel: hasNullOption ? options[0].label : undefined,
                options: options.filter((option, index) =>
                  hasNullOption ? index > 0 : true
                ),
              };
            })
            .filter((filter) => filter.label !== "Newest"),
        },
      }),
  });

  mountVue({
    selector: "#individuals-container",
    render: (t) =>
      t(IndividualsPage, {
        props: {
          filters: window.__DATA__.individuals_filters
            .filter((filter) => filter.option_name !== "chapter_id")
            .map((filter) => {
              const isMultiple = ["skill_tag_id"].includes(filter.option_name);
              const options = filter.options.map((option) => ({
                label: option.name,
                value: option.val.toString(),
              }));

              return {
                ...filter,
                id: filter.option_name,
                multiple: isMultiple,
                nullLabel: isMultiple ? options[0].label : undefined,
                options: options.filter((option, index) =>
                  isMultiple ? index > 0 : true
                ),
              };
            }),
        },
      }),
  });

  mountVue({
    selector: "#preview-card-container",
    render: (t) => t(PreviewCard),
  });

  mountVue({
    selector: "#checkout-container",
    render: (t) =>
      t(Checkout, {
        props: {
          plan: window.__DATA__.checkout_plan,
          initialBillingPeriod: window.__DATA__.checkout_billing_period,
          braintreeLocale: window.__DATA__.checkout_braintree_locale,
          braintreeClientToken: window.__DATA__.checkout_braintree_client_token,
        },
      }),
  });

  mountVue({
    selector: "#donation-form",
    render: (t) => t(DonationForm, {
      props: {
        braintreeLocale: window.__DATA__.checkout_braintree_locale,
        braintreeClientToken: window.__DATA__.checkout_braintree_client_token,
      },
    }),
  });

  mountComponents();

  setScrollbarWidth()
  initYoutubeIframeAPI();
  fitvids();
});



// WEBPACK FOOTER //
// ./app/javascript/packs/main.js